import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { observer } from 'mobx-react-lite';
import { Modal } from '@fluentui/react/lib/Modal';
import { getDocument, getFirstFocusable } from '@fluentui/react/lib/Utilities';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';
import { getFullCalendarEvent } from 'owa-calendar-surface-full-event-locked-store';
import { lazyHideReadingPane } from 'owa-calendar-reading-pane-actions';
import readingPaneStore from 'owa-calendar-reading-pane-store/lib/store/store';
import { ReadingPane, ModalCalendarReadingPane } from 'owa-calendar-reading-pane-view';
import { lazyConfirmCloseNotesEditorIfNeededAndContinue } from 'owa-meeting-forms-common';
import * as React from 'react';
import { isEventFromContextMenu } from '../utils/isEventFromContextMenu';
import styles from './ReadingPanePanel.scss';

// TODO: VSO #88707 Separate module vs surface concerns in Calendar module
// Reading pane should not have explicit dependency on surface view or surface store

/**
 * This is the calendar ReadingPane panel which shows on the surface when we click on calendar Item
 */
export default observer(function ReadingPanePanel() {
    let currentDoc: Document = getDocument();
    let focusElementOnNavigation = currentDoc
        ? (currentDoc.getElementById(getSurfaceStore().selectedItemCSSSelector) as HTMLElement)
        : null;
    // Show the modal only if the item exists
    const item = readingPaneStore.viewState
        ? getFullCalendarEvent(null, readingPaneStore.viewState.itemId)
        : null;

    if (!readingPaneStore.viewState?.showModal || !item) {
        return null;
    }

    if (isHostAppFeatureEnabled('readingPaneModal')) {
        return (
            <Modal
                allowTouchBodyScroll={true}
                isOpen={true}
                onDismiss={onPanelDismiss}
                isBlocking={false}
                elementToFocusOnDismiss={getFirstFocusable(
                    focusElementOnNavigation,
                    focusElementOnNavigation,
                    true /* includeElementsInFocusZones */
                )}
                containerClassName={styles.dialog}
                forceFocusInsideTrap={
                    false /* forceFocusInsideTrap is not compatible with iframes and dialogs (both used by add-ins) */
                }>
                <ModalCalendarReadingPane />
            </Modal>
        );
    } else {
        return <ReadingPane />;
    }
});

/**
 * Function that gets called when the panel is dismissed
 */
function onPanelDismiss(ev?: React.MouseEvent | React.KeyboardEvent) {
    if (isEventFromContextMenu(ev)) {
        ev.stopPropagation();
        return;
    }
    const item = getFullCalendarEvent(null, readingPaneStore.viewState.itemId);
    lazyConfirmCloseNotesEditorIfNeededAndContinue.importAndExecute(
        item.ItemId,
        lazyHideReadingPane.importAndExecute
    );
}
